import { ApiResult, httpRequest, Urls } from './Shared';
import { Property } from './Property';

const COMPANY_URL = '/Companies';
const WARM_LEADS_URL = '/Companies/WarmLeads'; 

export interface CompanyUpdate {
    name: string;
    contactEmail: string;
    contactPhone: string;
    salesforceClientId: string;
    applicationWidgetStatus: boolean;
    smartrent: SmartRent;
    keyCafeGroupId: string;
}

export interface SmartRent {
    key: string;
    secret: string;
}

export interface Company extends CompanyUpdate {
    id: number;
    smartrent: SmartRent;
}

export interface WarmLeads {
    properties: string;
    notes: string;
}

export const getCompany = (id: number): Promise<ApiResult<Company>> => {
    return httpRequest<Company>(`${Urls.BASE_URL}${COMPANY_URL}/${id}`, 'get');
};

export const updateCompany = (
    id: number,
    companyUpdate: CompanyUpdate
): Promise<ApiResult<undefined>> => {
    return httpRequest<undefined>(`${Urls.BASE_URL}${COMPANY_URL}/${id}`, 'put', companyUpdate);
};

export const getCompanyProperties = (id: number): Promise<ApiResult<Property[]>> => {
    return httpRequest<Property[]>(`${Urls.BASE_URL}${COMPANY_URL}/${id}/Properties`, 'get');
};

export const createCompany = (companyUpdate: CompanyUpdate): Promise<ApiResult<Company>> => {
    return httpRequest<Company>(`${Urls.BASE_URL}${COMPANY_URL}`, 'post', companyUpdate);
};

export const getCompaniesList = (): Promise<ApiResult<Company[]>> => {
    return httpRequest<Company[]>(`${Urls.BASE_URL}${COMPANY_URL}/Companies`, 'get');
};

export const deleteCompany = (id: number): Promise<ApiResult<undefined>> => {
    return httpRequest<undefined>(`${Urls.BASE_URL}${COMPANY_URL}/${id}`, 'delete');
};

export const addWarmLeads = (warmLeads: WarmLeads): Promise<ApiResult<Company>> => {
    return httpRequest<Company>(`${Urls.BASE_URL}${WARM_LEADS_URL}`, 'post', warmLeads);
};


// WEBPACK FOOTER //
// ./src/api/Company.ts